import RiotControl from 'riotcontrol'
import riotRoute from 'riot-route'
import logger from '../logger'
import { findIndex } from 'lodash-es'

// /////////////////////////
// Page Transition Mixin //
// /////////////////////////

export default {
  init() {
    RiotControl.on('hideAndNavigate', this.hideAndNavigate)
  },
  hideAndNavigate(route, replaceHistory = false) {
    if (!this.appModel) {
      riotRoute(route, null, replaceHistory)
      return
    }
    let r

    // always use the correct index
    const index = findIndex(this.appModel.sections, { uid: this.page_uid })

    // If the application is in editMode
    // go straight to review because user
    // is editing something from that page
    if (this.appModel.isInEditMode && !this.appModel.isFromNavigation) {
      logger('returning to the order-summary page', 'info')()
      r = '/order-summary'
    } else {
      this.appModel.isFromNavigation = false
      r = route || `/${this.appModel.sections[index + 1].route}`
    }
    this.hide('.wrap', () => {
      logger('Routing to: ', r, 'info')()
      riotRoute(r)
      RiotControl.trigger('notifyEditMode', false)
    })
    this.hide('.section-header-wrap')
  },
}
